module.exports = "<div class=divider-group> <div class=\"q-checkmark-radio q-cr-with-label\"> <label> <input type=radio data-operator=\"{%- operator %}\" name=\"{%- name %}\" value=\"{%- value %}\" class=filter-modal-input {% if (active) { %} checked=checked {% } %} /> <span class=q-checkmark-radio-label-inner></span> <span class=q-cr-label>{%- title %}</span> </label> </div> <div class=child-filters-entry {% if (!active) { %} style=display:none {% } %}> {%= childFiltersHtml %} </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/filterGroupRadio.html
// module id = 1149
// module chunks = 1